import { call, put, takeEvery, all, select } from "redux-saga/effects";
import decisionLogService from "../services/decisionLog.service";
import { generalActions } from "../actions";
import {
  sortDecisionLogAttempt,
  getDecisionLogAttempt,
  createDecisionLogAttempt,
  updateDecisionLogAttempt,
  deleteDecisionLogAttempt,
  updateDecisionLogFlagAttempt,
} from "../actions/decisionLog.actions";
import ACTIONS from "../constants";
import { decisionLogPagination } from "../selectors/decisionLog.selector";

function* sortDecisionLog(action) {
  const {
    payload: { id, orderBy, page, size },
  } = action;

  yield put(sortDecisionLogAttempt.pending);

  try {
    const response = yield call(decisionLogService.sortDecisionLogRequest, {
      id,
      orderBy,
      page,
      size,
    });
    const pagination = JSON.parse(response.headers["x-pagination"]);
    const data = {
      data: response.data,
      pagination: pagination,
    };

    yield put(sortDecisionLogAttempt.success(data));
  } catch (error) {
    yield put(sortDecisionLogAttempt.error(error));
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
  }
}

function* getDecisionLog(state) {
  try {
    yield put(getDecisionLogAttempt.pending);
    const response  = yield call(decisionLogService.getDecisionLogRequest, state.payload);
    const pagination = JSON.parse(response.headers["x-pagination"]);
    const data = {
      data: response.data,
      pagination: pagination,
    };

    yield put(getDecisionLogAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(getDecisionLogAttempt.error(""));
    } else {
      yield put(getDecisionLogAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
  }
}

function* createDecisionLog(action) {
  const {
    payload: { projectId, programId, payload },
  } = action;

  yield put(createDecisionLogAttempt.pending);

  try {
    const response = yield call(decisionLogService.createDecisionLogRequest, {
      projectId,
      payload,
    });

    let listResponse;
    if (programId) {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Program",
        id: programId,
        page: 1,
        size: 10,
      });
    } else {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Project",
        id: projectId,
        page: 1,
        size: 10,
      });
    }

    const pagination = JSON.parse(listResponse.headers["x-pagination"]);
    const data = {
      data: listResponse.data,
      pagination: pagination,
    };

    yield put(createDecisionLogAttempt.success(data));

    yield put(
      generalActions.showToast({
        title: "Decision log created successfully.",
        type: "success",
      })
    );
  } catch (error) {
    yield put(createDecisionLogAttempt.error(error));
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
  }
}

function* updateDecisionLog(action) {
  const {
    payload: { id, projectId, programId, payload },
  } = action;

  yield put(updateDecisionLogAttempt.pending);

  try {
    const response = yield call(decisionLogService.updateDecisionLogRequest, {
      id,
      projectId,
      payload,
    });

    const paginat = yield select(decisionLogPagination);
    
    let listResponse;
    if (programId) {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Program",
        id: programId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    } else {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Project",
        id: projectId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    }

    const pagination = JSON.parse(listResponse.headers["x-pagination"]);
    const data = {
      data: listResponse.data,
      pagination: pagination,
    };

    yield put(updateDecisionLogAttempt.success(data));

    yield put(
      generalActions.showToast({
        title: "Decision log updated successfully.",
        type: "success",
      })
    );
  } catch (error) {
    yield put(updateDecisionLogAttempt.error(error));
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
  }
}

function* deleteDecisionLog(action) {
  const {
    payload: { projectId, programId, id },
  } = action;

  yield put(deleteDecisionLogAttempt.pending);

  try {
    const response = yield call(decisionLogService.deleteDecisionLogRequest, {
      id,
    });

    const paginat = yield select(decisionLogPagination);
    
    let listResponse;
    if (programId) {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Program",
        id: programId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    } else {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Project",
        id: projectId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    }

    const pagination = JSON.parse(listResponse.headers["x-pagination"]);
    const data = {
      data: listResponse.data,
      pagination: pagination,
    };

    yield put(deleteDecisionLogAttempt.success(data));

    yield put(
      generalActions.showToast({
        title: "Decision log deleted successfully.",
        type: "success",
      })
    );
  } catch (error) {
    yield put(deleteDecisionLogAttempt.error(error));
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
  }
}

function* updateDecisionLogFlag(action) {
  const {
    payload: { id, projectId, programId, payload },
  } = action;

  yield put(updateDecisionLogFlagAttempt.pending);

  try {
    const response = yield call(
      decisionLogService.updateDecisionLogFlagRequest,
      {
        id,
        projectId,
        payload,
      }
    );

    const paginat = yield select(decisionLogPagination);
    
    let listResponse;
    if (programId) {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Program",
        id: programId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    } else {
      listResponse = yield call(decisionLogService.getDecisionLogRequest, {
        parent: "Project",
        id: projectId,
        page: paginat?.CurrentPage || 1,
        size: paginat?.PageSize || 10,
      });
    }

    const pagination = JSON.parse(listResponse.headers["x-pagination"]);
    const data = {
      data: listResponse.data,
      pagination: pagination,
    };

    yield put(updateDecisionLogFlagAttempt.success(data));
  } catch (error) {
    yield put(updateDecisionLogFlagAttempt.error(error));
    yield put(
      generalActions.showToast({
        title: "Something went wrong. Please try again later.",
        type: "error",
      })
    );
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SORT_DECISION_LOG_CALL, sortDecisionLog),
    takeEvery(ACTIONS.DECISION_LOG_CALL, getDecisionLog),
    takeEvery(ACTIONS.CREATE_DECISION_LOG_CALL, createDecisionLog),
    takeEvery(ACTIONS.UPDATE_DECISION_LOG_CALL, updateDecisionLog),
    takeEvery(ACTIONS.DELETE_DECISION_LOG_CALL, deleteDecisionLog),
    takeEvery(ACTIONS.DECISION_LOG_FLAG_CALL, updateDecisionLogFlag),
  ]);
} 